// extracted by mini-css-extract-plugin
module.exports = {"table":"YearEndReport__table--3aHMk","category":"YearEndReport__category--fewUA","name":"YearEndReport__name--1qEXz","limit":"YearEndReport__limit--3VG82"};